import { getMomentDate } from "../utils/commonUtils";

export default class PointChangeHistory {
  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = {}) {
    this.id = data.id || undefined;
    this.orderId = data.orderId || undefined;
    this.orderCode = data.orderCode || undefined;
    this.creditPoint = data.creditPoint || undefined;
    this.act = data.action || undefined;
    this.fromAccount = data.fromAccount || undefined;
    this.toAccount = data.toAccount || undefined;
    this.createdBy = data.createdBy || undefined;
    this.activityCode = data.activityCode || undefined;
    this.status = data.status || undefined;
    this.createdDate = getMomentDate(data.createdDate);
    this.updatedDate = getMomentDate(data.updatedDate);
    this.updatedBy = data.updatedBy || undefined;
    this.amount = data.amount || undefined
  }

  export() {
    return {
      id: this.id,
      orderId: this.orderId,
      orderCode: this.orderCode,
      creditPoint: this.creditPoint,
      act: this.act,
      fromAccount: this.fromAccount,
      toAccount: this.toAccount,
      createdBy: this.createdBy,
      activityCode: this.activityCode,
      status: this.status,
      createdDate: this.createdDate,
      updatedDate: this.updatedDate,
      updatedBy: this.updatedBy,
      amount: this.amount
    };
  }
}

